import { render, staticRenderFns } from "./supper-user.vue?vue&type=template&id=10a028a2&"
import script from "./supper-user.vue?vue&type=script&lang=js&"
export * from "./supper-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports